import React, { FC, ReactElement } from 'react';
import styled, { StyledComponent, DefaultTheme } from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { button, plainTextStyle } from '@westwing/ui-kit/typography';
import CloseIcon from '@westwing/ui-kit/Icons/CloseIcon';
import HybridLink, { Props } from './Links/HybridLink';

const SyledCloseIcon = styled(CloseIcon)`
    margin: 0 7px 0 3px;
`;

interface StyledNavLinkProps extends Props {
    isselected: string;
}

export interface NavigationBaseData {
    name: string;
    link: string;
    isHidden?: boolean;
    isSelected: boolean;
}

export interface NavigationItemProps {
    categoryName: NavigationBaseData['name'];
    to: NavigationBaseData['link'];
    isSelected: NavigationBaseData['isSelected'];
    onClick: (label: string, isSelected: boolean) => void;
    innerRef?: (node: HTMLAnchorElement | null) => void;
}

export const StyledNavLink: StyledComponent<FC<StyledNavLinkProps>, DefaultTheme> = styled(HybridLink)<{
    isselected: string;
}>`
    ${plainTextStyle}
    height: 40px;
    border-radius: 20px;
    box-shadow: ${({ theme, isselected }) =>
        isselected === 'true'
            ? `inset 0 0 0 2px ${theme.colors.charcoal100}`
            : `inset 0 0 0 1px ${theme.colors.charcoal20}`};
    color: ${({ theme }) => theme.colors.charcoal100};
    position: relative;
    margin-right: 7px;
    padding-right: 15px;
    padding-left: 15px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    ${forTablet`
        margin-bottom: 7px;
    `}
`;

const StyledLabel = styled.div`
    ${button}
    margin: 0 auto;
    letter-spacing: 0.3px;
    line-height: 20px;
`;

const NavigationItem: FC<NavigationItemProps> = ({ to, onClick, isSelected, categoryName, innerRef }): ReactElement => {
    const handleClick = () => onClick(categoryName, isSelected);

    return (
        <StyledNavLink onClick={handleClick} to={to} isselected={isSelected.toString()} innerRef={innerRef}>
            {isSelected && <SyledCloseIcon size="13px" />}
            <StyledLabel>{categoryName}</StyledLabel>
        </StyledNavLink>
    );
};

export type NavigationItemType = typeof NavigationItem;

export default NavigationItem;
